module.exports = __webpack_public_path__ + "static/media/pink-back.1aba8415.png";